import script from "./ConversionHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./ConversionHistory.vue?vue&type=script&setup=true&lang=js"

import "./ConversionHistory.vue?vue&type=style&index=0&id=4247675f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4247675f"]])

export default __exports__